import { render, staticRenderFns } from "./modal-detail-koli.vue?vue&type=template&id=295ce5d4&"
import script from "./modal-detail-koli.vue?vue&type=script&lang=js&"
export * from "./modal-detail-koli.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports